export var ErrorType;
(function (ErrorType) {
    ErrorType["FileUpload"] = "fileupload";
    ErrorType["FileDownload"] = "filedownload";
})(ErrorType || (ErrorType = {}));
